import React, {
  RefObject,
  useEffect,
  useState,
} from 'react';
import Table from 'core/components/VirtualTable';
import isNil from 'lodash/isNil';
import {
  useMedia,
  useTableReset,
} from 'core/hooks';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import {
  UserDTO,
} from 'dtos';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Button from 'pages/Dashboard/components/Button';
import Dialog, {
  UserDialogParams,
} from 'views/EMR/Settings/Users/Dialog';
import {
  settingsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import columns from 'views/EMR/Settings/Users/columns';
import {
  getUsers,
} from 'views/EMR/Settings/transport';
import clsx from 'clsx';

export type UserView = Omit<UserDTO, 'title' | 'phoneNumber'> & {
  userTitle: {
    title: string;
    isRestricted?: boolean;
  };
  phoneNumber?: string | null;
};

export default function Users() {
  const { tableInstanceRef } = useTableReset();
  const { requestMedia } = useMedia();
  const [
    createUserParams,
    setCreateUserParams,
  ] = useState<UserDialogParams | null>(null);

  useEffect(() => {
    const unsubscribe = settingsEventChannel.on('onUsersChange', () => {
      tableInstanceRef?.current?.refetch?.();
    });
    return () => { unsubscribe(); };
  }, []);

  const onUserDialog = (data: UserDialogParams | null) => {
    setCreateUserParams(data);
  };

  return (
    <div className="h-full w-full flex flex-col gap-4">
      <div className="px-4">
        <Button
          className="!h-8"
          color="primary"
          variant="contained"
          startIcon={<PersonAddIcon className="!w-4 !h-4" />}
          onClick={() => { onUserDialog({}); }}
        >
          Add User
        </Button>
      </div>
      <div className=" relative flex flex-col flex-1 overflow-y-hidden">
        <div className="h-full w-full">
          <Table<UserView>
            instanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
            getData={getUsers}
            getRowId={(row) => row?.userId}
            queryParams={{ requestMedia }}
            dataKey="users"
            columns={columns}
            emptySlot="No User Found"
            classes={{
              header: 'px-4',
              scrollContainer: 'justify-center items-center',
              outerRow: '!w-[calc(100%-16px)] left-4',
              row: (row) => clsx('!items-center py-1', { '!opacity-70': !row.original?.isActive }),
            }}
            onRowClick={(table, row) => {
              onUserDialog({ data: row.original });
            }}
          />
        </div>
      </div>
      {!isNil(createUserParams) && (
        <Dialog
          {...createUserParams}
          onClose={() => { onUserDialog(null); }}
        />
      )}
    </div>
  );
}
